import type { KittingPickLine } from "./kittingPickModel";

export interface KittingPickInventorySelection {
  sku: string;
  storageLocation: string;
  transferOrderId?: number | null;
  transferOrderItemId?: number | null;
}

/** Selected SKU + sublocation on the kitting pick page (line chosen or SKU tile active). */
export function kittingPickInventorySelection(input: {
  selectedLine: KittingPickLine | null;
  selectedSku: string | null;
  selectedStorageLocation: string | null;
  candidateLines: KittingPickLine[];
}): KittingPickInventorySelection | null {
  if (input.selectedLine != null) {
    const transfer =
      input.selectedLine.job.kind === "transfer_order"
        ? {
            transferOrderId: input.selectedLine.job.transferOrderId ?? null,
            transferOrderItemId: input.selectedLine.job.transferOrderItemId ?? null,
          }
        : { transferOrderId: null, transferOrderItemId: null };
    return {
      sku: input.selectedLine.sku,
      storageLocation: input.selectedLine.storageLocation,
      ...transfer,
    };
  }
  if (
    input.selectedSku != null
    && input.selectedStorageLocation != null
    && input.candidateLines.length > 0
  ) {
    const transferCandidate = input.candidateLines.find((line) => line.job.kind === "transfer_order");
    return {
      sku: input.selectedSku,
      storageLocation: input.selectedStorageLocation,
      transferOrderId: transferCandidate?.job.transferOrderId ?? null,
      transferOrderItemId: transferCandidate?.job.transferOrderItemId ?? null,
    };
  }
  return null;
}

/** Distinct Megaventory SubLocation stops on the current pick route (for modal suggestions). */
export function kittingPickKnownStorageLocations(lines: KittingPickLine[]): string[] {
  const locations = new Set<string>();
  for (const line of lines) {
    locations.add(line.storageLocation);
  }
  return Array.from(locations).sort((left, right) =>
    left.localeCompare(right, undefined, { sensitivity: "base" }),
  );
}
